import { FunctionComponent } from 'react';
import { L12nText, useIsLargerThanWide, useModifiers, useAudioTrigger, useSettingsSlice } from '@pp/core';
import { useBetOnAllCallbackConnected } from '../hooks/useBetOnAllCallbackConnected';
import styles from './BetOnAll.module.css';
export interface BetOnAllProps {
  isCollapsed: boolean;
  isMax?: boolean;
  clickSound?: string;
  isDisabled?: boolean;
}
export const BetOnAll: FunctionComponent<BetOnAllProps> = ({ isCollapsed, isMax, clickSound, isDisabled }) => {
  const betOnAll = useBetOnAllCallbackConnected();
  const audioTrigger = useAudioTrigger();
  const isWideScreen: boolean = useIsLargerThanWide();
  const currentLanguage = useSettingsSlice.currentLanguage();
  const mods = useModifiers(styles, 'betOnAllButton', {
    isCollapsed: !!isCollapsed,
    isMax: isMax,
    isDisabled: isDisabled,
  });
  const handleClick = () => {
    if (clickSound) {
      audioTrigger.play({ name: clickSound });
    }
    betOnAll();
  };
  return (
    <div
      data-test-id={'betspot_betonall'}
      className={`${styles.betOnAllButton_container} ${mods} ${isWideScreen && styles.wideScreen__betOnAllButton}`}
    >
      <div className={styles.betOnAllButton_box}>
        <button className={`${styles.betOnAllButton} ${mods}`} disabled={isDisabled} onClick={handleClick}>
          <div className={styles.betOnAllButton__innerWrapper}>
            <div className={styles.betOnAllButton__border} />
            <div className={styles.imagesBetOnAll}>
              <div
                className={`${styles.betOnAllButton__label} ${
                  currentLanguage?.toLowerCase() != 'en' && styles.breakAll
                }`}
              >
                <L12nText tk="BETONALL" />
              </div>
            </div>
          </div>
        </button>
      </div>
      {isDisabled && <div className={styles.betOnAllButton_opacity}></div>}
    </div>
  );
};
